import { render, staticRenderFns } from "./file-word.vue?vue&type=template&id=13ba9354"
import script from "./file-word.vue?vue&type=script&lang=js"
export * from "./file-word.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports